import {
  ReferenceField as RaReferenceField,
  ReferenceFieldProps as RaReferenceFieldProps,
} from 'react-admin';

export const ReferenceField = RaReferenceField;

export type ReferenceFieldProps = RaReferenceFieldProps;
